module.exports = __webpack_public_path__ + "img/rank-2nd.848c907d.png";